import type { Cart, Store } from '@jane/shared/types';

export const getCheckoutWarningMessage = ({
  store,
  cart,
  showJanePay,
}: {
  cart: Cart;
  showJanePay: boolean;
  store: Store;
}) => {
  if (!store || !cart) return null;

  const hasGoldDeal = cart.brand_discounts_total;
  const whiteLabel = store.jane_pay_integration?.white_label
    ? store.jane_pay_integration.custom_payment_method_label
    : null;

  if (hasGoldDeal) {
    if (showJanePay) {
      return `You cannot earn Jane Gold cash back or pay with ${
        whiteLabel || 'Jane Pay'
      } when you check out anonymously.`;
    } else {
      return 'You cannot earn Jane Gold cash back when you check out anonymously.';
    }
  }

  if (showJanePay && !hasGoldDeal) {
    return `You cannot pay with ${
      whiteLabel || 'Jane Pay'
    } when you check out anonymously.`;
  }

  return null;
};
